import { ref, computed, onUnmounted } from 'vue'

export const loadingProps = {
  loading: {
    type: Boolean,
    default: false,
  },
  delay: {
    type: Number,
    default: 400,
  },
}

/**
 * Composable to manage delayed loading state
 * @param {number} delay - Delay in milliseconds before showing the loading state
 * @returns {object} - Contains isLoading state and functions to start/stop loading
 */
export function useDelayedLoader(delay = 400) {
  const isLoading = ref(false)
  const isDelayedLoading = ref(false)
  let delayTimeout = null

  const showLoading = () => {
    if (!isLoading.value) {
      isLoading.value = true
      delayTimeout = setTimeout(() => {
        isDelayedLoading.value = true
      }, delay)
    }
  }

  const hideLoading = () => {
    isLoading.value = false
    isDelayedLoading.value = false
    if (delayTimeout) {
      clearTimeout(delayTimeout)
      delayTimeout = null
    }
  }

  onUnmounted(() => {
    if (delayTimeout) {
      clearTimeout(delayTimeout)
    }
  })

  return {
    isLoading: computed(() => isLoading.value),
    isDelayedLoading: computed(() => isDelayedLoading.value),
    showLoading,
    hideLoading,
  }
}